import api from 'Application/api/api';

const createEpcPartner = (signal, values) =>
	api.post('/epcpartners', values, {
		signal,
	});

export default createEpcPartner;
